import React, { useState, useEffect } from "react";
import Web3 from "web3";
import { EthereumProvider } from "@walletconnect/ethereum-provider";
import BN from "bn.js"; // Import the bn.js library
import './App.css';

const contractABI = [{"inputs":[{"internalType":"address","name":"_token","type":"address"},{"internalType":"uint256","name":"_initialRate","type":"uint256"}],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"newRate","type":"uint256"}],"name":"RateChanged","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"claimer","type":"address"},{"indexed":false,"internalType":"uint256","name":"tokensClaimed","type":"uint256"}],"name":"TokensClaimed","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"funder","type":"address"},{"indexed":false,"internalType":"uint256","name":"tokensFunded","type":"uint256"}],"name":"TokensFunded","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"buyer","type":"address"},{"indexed":false,"internalType":"uint256","name":"bnbAmount","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"tokensReceived","type":"uint256"}],"name":"TokensPurchased","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"deployer","type":"address"},{"indexed":false,"internalType":"uint256","name":"unsoldTokens","type":"uint256"}],"name":"UnsoldTokensWithdrawn","type":"event"},{"inputs":[],"name":"buyTokens","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"uint256","name":"","type":"uint256"}],"name":"buyers","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"_newRate","type":"uint256"}],"name":"changeRate","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"claimTokens","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"contributions","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"deployer","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"endPresale","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_amount","type":"uint256"}],"name":"fundPresale","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"getSoldTokens","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getUnsoldTokens","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"presaleEnded","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"token","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"tokenRate","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"tokensBought","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalTokensAllocated","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"withdraw","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"withdrawUnsoldTokens","outputs":[],"stateMutability":"nonpayable","type":"function"}]; // Keep your contract ABI here
const contractAddress = "0xF93F9280471378DDfdb5c2714AE7A6435935f4ED";

const PresaleApp = () => {
  const [account, setAccount] = useState(null);
  const [web3, setWeb3] = useState(null);
  const [contract, setContract] = useState(null);
  const [bnbAmount, setBnbAmount] = useState("");
  const [tokensToReceive, setTokensToReceive] = useState(0);
  const [tokenRate, setTokenRate] = useState(0);
  const [bnbToUsdtRate, setBnbToUsdtRate] = useState(0); // State to store BNB to USDT rate
  const [isPresaleEnded, setIsPresaleEnded] = useState(false);
  const [newRate, setNewRate] = useState("");
  const [isDeployer, setIsDeployer] = useState(false);
  const [userTokenBalance, setUserTokenBalance] = useState(0); // State to store user token balance
  const [soldTokens, setSoldTokens] = useState(0); // State to store total sold tokens
  const [provider, setProvider] = useState(null); // State to store WalletConnect provider




 /* useEffect(() => {
    if (window.ethereum) {
      const web3Instance = new Web3(window.ethereum);
      setWeb3(web3Instance);

      const presaleContract = new web3Instance.eth.Contract(contractABI, contractAddress);
      setContract(presaleContract);
    } else {
      alert("Please install MetaMask!");
    }
  }, []);*/



  useEffect(() => {
    const initializeWeb3 = async () => {
      try {
        let web3Instance;
        let presaleContract;
  
        if (window.ethereum) {
          // Use MetaMask provider if available
          web3Instance = new Web3(window.ethereum);
          console.log("MetaMask detected.");
        } else {
          // Fallback to a public provider if MetaMask is not available
          const publicProviderUrl = "https://bsc-dataseed.binance.org/"; // Binance Smart Chain public RPC
          web3Instance = new Web3(new Web3.providers.HttpProvider(publicProviderUrl));
          console.log("Using fallback provider.");
        }
  
        setWeb3(web3Instance);
  
        // Initialize the contract
        presaleContract = new web3Instance.eth.Contract(contractABI, contractAddress);
        setContract(presaleContract);
  
        // Fetch contract data even if no wallet is connected
        const rate = await presaleContract.methods.tokenRate().call();
        setTokenRate(rate);
  
        const soldTokens = await presaleContract.methods.getSoldTokens().call();
        const soldTokensInEther = web3Instance.utils.fromWei(soldTokens, "ether");
        setSoldTokens(soldTokensInEther);
  
      } catch (error) {
        console.error("Error initializing Web3:", error);
      }
    };
  
    initializeWeb3();
  }, []);



  useEffect(() => {
    if (contract && account) {
      fetchTokenRate();
      fetchBnbToUsdtRate(); // Fetch BNB to USDT rate
      checkPresaleStatus();
      checkIfDeployer();
      fetchUserTokenBalance(); // Fetch user's token balance
      fetchSoldTokens(); // Fetch total sold tokens
    }
  }, [contract, account]);

  useEffect(() => {
    if (contract) {
      fetchSoldTokens(); // Fetch total sold tokens when contract is available
    }
  }, [contract]);

  const connectWallet = async () => {
    try {
      const accounts = await window.ethereum.request({ method: "eth_requestAccounts" });
      setAccount(accounts[0]);
    } catch (error) {
      console.error("MetaMask connection error:", error);
      alert("Could not connect to MetaMask.");
    }
  };


  
  const connectWalletConnect = async () => {
    try {
      const walletConnectProvider = await EthereumProvider.init({
        projectId: "fb898ab46e75db7eabb9363b099193c8", // Obtain this from WalletConnect Cloud
        chains: [56], // Replace with your target chain ID, e.g., 56 for Binance Smart Chain
        showQrModal: true, // Enable QR modal
      });
  
      await walletConnectProvider.connect();
      const web3Instance = new Web3(walletConnectProvider);
      setWeb3(web3Instance);
      setProvider(walletConnectProvider);
  
      const accounts = await web3Instance.eth.getAccounts();
      setAccount(accounts[0]);
  
      const presaleContract = new web3Instance.eth.Contract(contractABI, contractAddress);
      setContract(presaleContract);
    } catch (error) {
      console.error("WalletConnect v2 connection error:", error);
      alert("Could not connect with WalletConnect v2.");
    }
  };
  const disconnectWallet = async () => {
    if (provider && provider.disconnect) {
      await provider.disconnect();
    }
    setAccount(null);
    setWeb3(null);
    setContract(null);
  };


  
  const fetchTokenRate = async () => {
    try {
      const rate = await contract.methods.tokenRate().call();
      setTokenRate(rate);
    } catch (error) {
      console.error("Error fetching token rate:", error);
    }
  };

  const fetchBnbToUsdtRate = async () => {
    try {
      const response = await fetch("https://api.coingecko.com/api/v3/simple/price?ids=binancecoin&vs_currencies=usd");
      const data = await response.json();
      setBnbToUsdtRate(data.binancecoin.usd);
    } catch (error) {
      console.error("Error fetching BNB to USDT rate:", error);
    }
  };

  const checkPresaleStatus = async () => {
    try {
      const presaleEnded = await contract.methods.presaleEnded().call();
      setIsPresaleEnded(presaleEnded);
    } catch (error) {
      console.error("Error checking presale status:", error);
    }
  };

  const checkIfDeployer = async () => {
    try {
      const deployer = await contract.methods.deployer().call();
      if (account && deployer.toLowerCase() === account.toLowerCase()) {
        setIsDeployer(true);
      }
    } catch (error) {
      console.error("Error checking deployer status:", error);
    }
  };

  const fetchUserTokenBalance = async () => {
    try {
      if (contract && account) {
        const balance = await contract.methods.tokensBought(account).call();
        const balanceInEther = web3.utils.fromWei(balance, "ether"); // Convert to Ether for display
        setUserTokenBalance(balanceInEther);
      }
    } catch (error) {
      console.error("Error fetching user token balance:", error);
    }
  };

    const fetchSoldTokens = async () => {
    try {
      if (contract) {
        const sold = await contract.methods.getSoldTokens().call();
        const soldInEther = web3.utils.fromWei(sold, "ether"); // Convert to Ether for display
        setSoldTokens(soldInEther);
      }
    } catch (error) {
      console.error("Error fetching sold tokens:", error);
    }
  };

  const calculateTokens = (bnb) => {
    if (bnb && tokenRate > 0) {
      const bnbInWei = web3.utils.toWei(bnb, "ether");
      const tokenRateBN = new BN(tokenRate);
      const bnbInWeiBN = new BN(bnbInWei);
      const tokens = bnbInWeiBN.mul(tokenRateBN);

      const tokensAmount = web3.utils.fromWei(tokens.toString(), "ether");
      setTokensToReceive(tokensAmount);
    } else {
      setTokensToReceive(0);
    }
  };

  const handleBnbInput = (e) => {
    const bnb = e.target.value;
    setBnbAmount(bnb);
    calculateTokens(bnb);
  };

  const buyTokens = async () => {
    try {
      if (contract && account) {
        const value = web3.utils.toWei(bnbAmount, "ether");
        await contract.methods.buyTokens().send({ from: account, value });
        alert("Tokens purchased successfully!");
        fetchUserTokenBalance(); // Refresh user token balance after purchase
        fetchSoldTokens(); // Refresh total sold tokens after purchase
      }
    } catch (error) {
      console.error("Error buying tokens:", error);
      alert("An error occurred while trying to buy tokens.");
    }
  };

  const claimTokens = async () => {
    try {
      if (contract && account) {
        await contract.methods.claimTokens().send({ from: account });
        alert("Tokens claimed successfully!");
        fetchUserTokenBalance(); // Refresh user token balance after claiming
      }
    } catch (error) {
      console.error("Error claiming tokens:", error);
      alert("An error occurred while trying to claim tokens.");
    }
  };

  const changeTokenRate = async () => {
    try {
      if (contract && account) {
        const rate = parseInt(newRate, 10);
        await contract.methods.changeRate(rate).send({ from: account });
        alert("Token rate updated successfully!");
        fetchTokenRate();
      }
    } catch (error) {
      console.error("Error changing token rate:", error);
      alert("An error occurred while trying to change the token rate.");
    }
  };

  const getTokenRateInUSDT = () => {
    try {
      console.log("BNB to USDT Rate:", bnbToUsdtRate);
      console.log("Token Rate in BNB:", tokenRate);
  
      // Ensure both rates are valid numbers
      if (bnbToUsdtRate > 0 && tokenRate > 0) {
        // Adjust token rate for decimals
        const tokenDecimals = 18; // Token decimal places (adjust if necessary)
        const tokenRateInBNB = parseFloat(tokenRate);
  
        // Calculate the token rate in USDT
        const tokenRateInUSDT = bnbToUsdtRate / tokenRateInBNB;
  
        console.log("Token Rate in USDT before rounding:", tokenRateInUSDT);
  
        // Limit the result to a reasonable precision
        const roundedTokenRateInUSDT = parseFloat(tokenRateInUSDT); // 2 decimal places for clarity
        console.log("Token Rate in USDT after rounding:", roundedTokenRateInUSDT);
  
        // Return the formatted rate
        return roundedTokenRateInUSDT.toFixed(4); // 2 decimal places for display
      }
  
      return "Loading...";
    } catch (error) {
      console.error("Error calculating token rate in USDT:", error);
      return "Error USD per Token";
    }
  };
  
  


  return (
<div className="body">
  <div className="app-container">
    <h1 className="main-heading">🚀 Welcome to XReplicas Presale</h1>

    {/* Wallet Connection Section */}
    {!account ? (
      <div className="connect-container">
        <h2 className="connect-title">Connect Your Wallet to Begin</h2>
        <p className="connect-description">
          Securely connect your wallet to participate in the presale and manage your tokens.
        </p>
{/* Total Tokens in Presale Section */}
<div className="total-presale-info">
          <h3>Total Presale Information</h3>
          <h4>Total Tokens Sold: <span>{soldTokens}</span> / 400,000,000 Tokens</h4> {/* Hardcoded total tokens in presale */}
          
        </div>

        {/* Stage 1 Information Section */}
        <div className="stage-info">
          <h3>Stage 1</h3>
          <p>Tokens Sold: <span>{soldTokens}</span> / 50,000,000 Tokens</p> {/* 1 million tokens for Stage 1 */}
          <div className="progress-bar-container">
            <div
              className="progress-bar"
              style={{
                width: `${(soldTokens / 50000000) * 100}%`,
              }}
            >
              <span className="percentage-text">
                {((soldTokens / 50000000) * 100).toFixed(2)}%
              </span>
            </div>
          </div>
        </div>
        {/* Wallet Connect Buttons */}
        <div className="connect-buttons">
          <button className="connect-button futuristic-button" onClick={connectWallet}>
            <img src="metamask-icon.png" alt="MetaMask" className="button-icon" /> Connect MetaMask
          </button>
          <button className="connect-button futuristic-button" onClick={connectWalletConnect}>
            <img src="wallet_connect_icon.png" alt="WalletConnect" className="button-icon" /> Connect WalletConnect
          </button>
        </div>
      </div>
    ) : (
      <div className="wallet-info">
        {/* Account Information Section */}
        <div className="account-info">
          <p>Connected Account: <span>{account}</span></p>
          <button onClick={disconnectWallet} className="disconnect-button">Disconnect Wallet</button>
          <p>Your Token Balance: <span>{userTokenBalance}</span> Tokens</p>
        </div>

        {/* Total Tokens in Presale Section */}
        <div className="total-presale-info">
          <h3>Total Presale Information</h3>
          <h4>Total Tokens Sold: <span>{soldTokens}</span> / 400,000,000 Tokens</h4> {/* Hardcoded total tokens in presale */}
          
        </div>

        {/* Stage 1 Information Section */}
        <div className="stage-info">
          <h3>Stage 1</h3>
          <p>Tokens Sold: <span>{soldTokens}</span> / 50,000,000 Tokens</p> {/* 1 million tokens for Stage 1 */}
          <div className="progress-bar-container">
            <div
              className="progress-bar"
              style={{
                width: `${(soldTokens / 50000000) * 100}%`,
              }}
            >
              <span className="percentage-text">
                {((soldTokens / 50000000) * 100).toFixed(2)}%
              </span>
            </div>
          </div>
        </div>

        {/* Token Rate Information Section */}
        <div className="rate-info">
          <p>Token Rate: <span>{tokenRate}</span> Tokens per 1 BNB</p>
          <p>Token Rate in USDT: <span>{getTokenRateInUSDT()}</span> USD per Token</p>
        </div>

        {/* Buy Section */}
        <div className="buy-section">
          <h3>Buy Tokens</h3>
          <input
            type="number"
            placeholder="Enter BNB amount"
            value={bnbAmount}
            onChange={handleBnbInput}
            className="bnb-input"
          />
          <p>Tokens You Will Receive: <span>{tokensToReceive}</span></p>
          <button onClick={buyTokens} className="buy-button futuristic-button" disabled={isPresaleEnded}>
            {isPresaleEnded ? "Presale Ended" : "Buy"}
          </button>
        </div>

        {/* Claim Section */}
        {isPresaleEnded && (
          <div className="claim-section">
            <h3>Claim Tokens</h3>
            <button onClick={claimTokens} className="claim-button">Claim</button>
          </div>
        )}

        {/* Deployer Section */}
        {isDeployer && (
          <div className="rate-change-section">
            <h3>Change Token Rate</h3>
            <input
              type="number"
              placeholder="Enter new rate"
              value={newRate}
              onChange={(e) => setNewRate(e.target.value)}
              className="rate-input"
            />
            <button onClick={changeTokenRate} className="change-rate-button">Change Rate</button>
          </div>
        )}
      </div>
    )}
  </div>
</div>


  );
};

export default PresaleApp;
